<template>
  <div class="pluss h-view overflow-auto">
    <!-- Desktop version -->
    <div class="h-view bg-ul-gray-300 text-ul-orange-50 font-display relative hidden font-medium lg:block">
      <div class="flex h-5/6 flex-row">
        <div class="relative flex w-1/2 items-center justify-center bg-white">
          <VideoPlayer
            url="https://firebasestorage.googleapis.com/v0/b/ulno-1557913587891.appspot.com/o/video%2FUL%2B.mp4?alt=media"
            class="w-full border-12 border-white object-cover"
          />
        </div>
        <div class="flex w-1/2 flex-col">
          <div class="flex h-7/12 flex-row">
            <div class="flex h-full w-3/12 flex-col">
              <img :src="konsertImage" role="presentation" class="h-3/5 w-full object-cover" />
              <img :src="plussImage" role="presentation" class="h-2/5 w-full object-cover" />
            </div>
            <div class="flex h-full w-4/12 flex-col">
              <img :src="climbImage" role="presentation" class="h-1/2 w-full object-cover" />
              <img :src="kaffeImage" role="presentation" class="h-1/2 w-full object-cover" />
            </div>
            <div class="flex h-full w-5/12 flex-col">
              <img :src="lovsangImage" role="presentation" class="h-3/5 w-full object-cover" />
              <div class="flex h-2/5 w-full items-center justify-center text-center text-4xl xl:text-5xl 2xl:text-6xl">
                {{ EVENT_DATE }}
              </div>
            </div>
          </div>
          <div
            class="bg-ul-gray-400 flex h-1/6 w-full items-center justify-center text-center text-3xl xl:text-4xl 2xl:text-5xl"
          >
            Lyngdal
          </div>
          <div class="relative flex h-1/4 flex-row">
            <img :src="praiseImage" role="presentation" class="h-full w-full object-cover" />
            <div
              class="bg-ul-gray-300 text-cente absolute top-0 left-0 flex h-1/3 w-1/2 flex-row items-center justify-center text-2xl xl:text-3xl 2xl:text-4xl"
            >
              Festival som forandrer
            </div>
            <div class="absolute right-0 bottom-0 flex h-1/3 w-7/12 flex-row">
              <div
                class="bg-ul-gray-100 text-ul-gray-400 flex w-1/4 items-center justify-center text-center text-3xl xl:text-4xl 2xl:text-5xl"
              >
                21+
              </div>
              <div
                class="bg-ul-gray-300 flex w-3/4 items-center justify-center text-center text-2xl xl:text-3xl 2xl:text-4xl"
              >
                Festival i festivalen
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex h-1/6 flex-row">
        <div class="flex w-3/5 flex-row">
          <GridImageButton
            v-for="linkBox in linkBoxes"
            :key="linkBox.text"
            :image="linkBox.image"
            :text="linkBox.text"
            :link="linkBox.link"
            color="gray"
            class="w-1/4 text-lg xl:text-2xl 2xl:text-4xl"
          />
        </div>
        <div class="flex w-2/5 flex-row">
          <img :src="paintImage" role="presentation" class="h-full w-1/2 object-cover" />
          <img :src="seminarImage" role="presentation" class="h-full w-1/2 object-cover" />
        </div>
      </div>
    </div>

    <!-- Mobile version -->
    <div class="h-view bg-ul-gray-300 text-ul-orange-50 font-display relative font-medium lg:hidden">
      <div class="flex h-full flex-col">
        <div class="flex h-1/3 w-full items-center justify-center bg-white">
          <VideoPlayer
            url="https://firebasestorage.googleapis.com/v0/b/ulno-1557913587891.appspot.com/o/video%2FUL%2B.mp4?alt=media"
            class="max-h-full w-full border-12 border-white object-cover"
          />
        </div>

        <div class="flex h-1/8 flex-row">
          <img :src="plussImage" role="presentation" class="h-full w-2/5 object-cover" />
          <div class="xs:text-5xl flex w-3/5 items-center justify-center text-center text-4xl sm:text-6xl md:text-7xl">
            {{ EVENT_DATE }}
          </div>
        </div>

        <div class="flex h-1/8 flex-row">
          <img :src="lovsangImage" role="presentation" class="h-full w-1/5 object-cover" />
          <img :src="talkshowImage" role="presentation" class="h-full w-2/5 object-cover" />
          <img :src="seminarImage" role="presentation" class="h-full w-2/5 object-cover" />
        </div>

        <div class="flex h-1/12 flex-row">
          <img :src="programImage" role="presentation" class="h-full w-5/12 object-cover" />
          <div
            class="bg-ul-gray-100 text-ul-gray-400 xs:text-5xl flex w-1/4 items-center justify-center text-center text-4xl sm:text-6xl md:text-7xl"
          >
            21+
          </div>
          <img :src="campingImage" role="presentation" class="h-full w-4/12 object-cover" />
        </div>

        <div
          class="bg-ul-gray-400 xs:text-3xl flex h-1/8 items-center justify-center text-center text-2xl sm:text-4xl md:text-5xl"
        >
          Lyngdal
        </div>

        <div class="flex h-1/8 flex-row">
          <img :src="climbImage" role="presentation" class="h-full w-2/5 object-cover" />
          <div
            class="bg-ul-gray-200 text-ul-gray-400 xs:text-3xl flex w-3/5 items-center justify-center text-center text-2xl sm:text-4xl md:text-5xl"
          >
            Festival som forandrer
          </div>
        </div>

        <div class="flex min-h-0 grow flex-row">
          <img :src="rockClimbingImage" role="presentation" class="h-full w-1/6 object-cover" />
          <img :src="ticketsImage" role="presentation" class="h-full w-3/6 object-cover" />
          <img :src="paintImage" role="presentation" class="h-full w-2/6 object-cover" />
        </div>
      </div>
    </div>

    <PageFooter />
  </div>
</template>

<script setup lang="ts">
import campingImage from '../assets/images/camping.jpg'
import climbImage from '../assets/images/climb.jpg'
import kaffeImage from '../assets/images/kaffe.jpg'
import konsertImage from '../assets/images/konsert.jpg'
import lovsangImage from '../assets/images/lovsang.jpg'
import paintImage from '../assets/images/paint.jpg'
import plussImage from '../assets/images/pluss.jpg'
import praiseImage from '../assets/images/praise3.jpg'
import programImage from '../assets/images/program.jpg'
import rockClimbingImage from '../assets/images/rock-climbing.png'
import seminarImage from '../assets/images/seminar.jpg'
import talkshowImage from '../assets/images/talkshow.jpg'
import ticketsImage from '../assets/images/tickets.jpg'
import GridImageButton from '../components/GridImageButton.vue'
import PageFooter from '../components/PageFooter.vue'
import VideoPlayer from '../components/VideoPlayer.vue'
import { EVENT_DATE } from '../lib/constants'

const linkBoxes = [
  { text: 'UL+ Program', link: '/program#pluss', image: campingImage },
  { text: 'Billetter', link: '/billetter', image: rockClimbingImage },
  {
    text: 'UL+ Aktiviteter',
    link: '/info#aktiviteter-ulpluss',
    image: programImage,
  },
  { text: 'UL+ Overnatting', link: '/info#overnatting', image: ticketsImage },
]
</script>

<style lang="scss"></style>
